import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { Toaster } from 'react-hot-toast'
import store from './store/index'
import { Provider } from 'react-redux'
import './index.css';
import Loading from './views/components/Loading'
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from "react-helmet-async";

const App = lazy(() => import('./App'))
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HelmetProvider>
  <BrowserRouter>
    <Provider store={store}>
      <Suspense fallback={<Loading />}>
        <App />
        <Toaster
          toastOptions={{
            position: 'top-right',
            style: {
              background: '#283046',
              color: 'white'
            }
          }}
        />
      </Suspense>
    </Provider>
  </BrowserRouter>
  </HelmetProvider>
);
reportWebVitals();
